import React, { Component } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { TextField } from "@material-ui/core";
import { Link, Redirect } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import Razorpay from 'razorpay';
import Axios from 'axios';
import moment from 'moment';
import * as auth from "../../store/ducks/auth.duck";
import { requestPassword } from "../../crud/auth.crud";
import { toast } from 'react-toastify';
import { Card, Table,  Spinner, Breadcrumb, Button  } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, CardBody } from "reactstrap";
import dateFormat from 'dateformat';
var CryptoJS = require("crypto-js");



class Paymentpage extends Component { 
  state = { isRequested: false, "ordId" : "", "userId": "","totalprice" : "" };
  
  constructor(props) {
    super(props);
    this.state = {
      "pay_amount":"",
      "amount": "",
      cashondelivery:"0",
      razor:"0",
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
      wal_amount: 0,
      modal: false,
      userData: [],
      paymentData: [],
      orderdetails: [],
      totalprice: "",
      "ordId":"",
      custId:"",
      orddelId:"",
      paystatus:"",
     f_address:"",
     ordercontinue:"",
     paySlot: false,
     usid: "",
     uemail:"",
     uphonenumber:"",
	 paymentidmode:"",

    };
    this.changeAmount = this.changeAmount.bind(this);
    this.openCheckout = this.openCheckout.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }
  changeAmount = (e) =>  {
    this.setState({ pay_amount: e.target.value});
    this.setState({amount: 100 * e.target.value})
  }

  openCheckout() {
    console.log( this.props.userId)
    let options = {
      "key": this.state.paymentidmode,
      "amount": 100 * this.state.totalprice, // 2000 paise = INR 20, amount in paisa
      "name": "Gowatr",
      "user_d": this.state.usid,
      "description": "Order Payment",
      "image": "/media/logos/newlogo.png",
      "prefill": {
        // "name": "Harshil Mathur",
         "email": this.state.uemail,
         "contact": this.state.uphonenumber
       },
      handler: async (response) => {
        try {
          const API_URL = process.env.REACT_APP_NODE_ENV;
          const bodyParameters = { 
            amount_data: 100 * this.state.totalprice,
            acc_amount: this.state.pay_amount,  
            user_id: this.props.userId,
            ords_id: this.state.ordId, 
            transtype: 'deposit'

         };
          

         const paymentId = response.razorpay_payment_id;
         const url = `${API_URL}/api/orderpayment/${paymentId}`;
         const captureResponse = await Axios.post(url,bodyParameters, {})
        
         if(captureResponse.data) {
          const doesToggle = this.state.paySlot;
          this.setState({  paySlot: !doesToggle });
         
           console.log(this.state.ordercontinue)
			let data_string= 
			{
				paymentdetails: captureResponse.data,
				user_id: this.state.usid, 
				p_id: captureResponse.data.paymentid,
				ordcontinue: this.state.ordercontinue,
				passdata:"paymentrazor"
			} 
		  localStorage.setItem('pay_data', '')
          localStorage.setItem('pay_data', JSON.stringify(data_string));
          this.props.history.push({ pathname: "/order/payedsuccess"});

         }
        } catch (err) { 
          console.log(err);
        }
      },
      "theme": {
        "color": "#000080"  
      }
    };

    const rzp1 = new window.Razorpay(options);
       rzp1.open();
  }

  handleChange = (e) => {
    const item = e.target.name;
    const isChecked = e.target.checked;
	  if(e.target.value == 'COD') 
    {
      this.setState({cashondelivery: '1'})
      //this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));
    }
    // 
   
    //this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));

  }
  onChangeValue(event) {
   
   
   
    if(event.target.value == 'COD') 
    {
      this.setState({cashondelivery: '1'})
      this.setState({paystatus : '1'})
      //this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));
    }

    else if(event.target.value == 'razorpay' ) 
    {
		
			this.setState({razor : '1' });
			this.setState({paystatus : '2'})
		
    }
    else {
     // this.setState({razor : '1' });
      this.setState({paystatus : '3'})
    }
  
   
  }
  razorpay = (e) => {
    const item = e.target.name;
    const isChecked = e.target.checked;
   
    //this.openCheckout();
   // this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));
  }

  submit = (e) => {
    e.preventDefault();

      

     if( this.state.paystatus === '1' ) {
      this.cashondelivery();
    }
    else if( this.state.paystatus === '2' ) {
      this.openCheckout();
    }
    else {
      this.walletpay(e)
    }
  
  }
  walletpay = (e) =>  {
    
    if(this.state.wal_amount >=  this.state.totalprice) 
    {
      let  bodyParameters = { 
        order_price:  this.state.totalprice,
        user_id: this.state.usid,
        ords_id: this.state.ordId, 
        transtype: 'withdrawal',
        curr_data:'INR',
        uemail: this.state.uemail,
        umobile: this.state.uphonenumber,

       
     }
     
     
    
    fetch(process.env.REACT_APP_NODE_ENV + '/api/wallet/transaction', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(bodyParameters)
    }).then((response) => response.json())
      .then(data => {
        if(data) {
          
          localStorage.removeItem("pay_data");
          
          let data_string= {
            paymentdetails: data.data_get,
            user_id: this.state.usid, 
            p_id: data.payment_id,
            ordcontinue: this.state.ordercontinue,
            passdata : 'wallet'

           

          } 
          localStorage.setItem('pay_data', JSON.stringify(data_string));


          this.props.history.push({ pathname: "/order/payedsuccess" }); 



        }
        //this.setState({ wal_amount : data.wallet_amount })
        //console.log(data.wallet_amount)
      }) 
      
    }
    else  {
      let payment_price= this.state.totalprice  - this.state.wal_amount
      if(payment_price == '0') {


      }
      else {
        let  bodyParameters_data = { 
          order_price:  this.state.totalprice,
          user_id: this.state.usid,
          ords_id: this.state.ordId, 
          transtype: 'withdrawal',
          curr_data:'INR',
          uemail: this.state.uemail,
          umobile: this.state.uphonenumber,
  
         
  
       }
        this.paymentorder(bodyParameters_data)
       // console.log(payment_price)
       // console.log('successfully2') 

      }
      
    }

  }

  paymentorder(bodyParameters_data) {
    console.log(bodyParameters_data)
    const addamount= ""
    if(bodyParameters_data.order_price >= this.state.wal_amount) {
      const addamount =  bodyParameters_data.order_price -  this.state.wal_amount
      let options = {
        "key": this.state.paymentidmode,
        "amount": 100 * addamount, // 2000 paise = INR 20, amount in paisa
        "name": "Gowatr",
        "user_d": this.state.usid,
        "description": "Order Payment",
        "image": "/media/logos/newlogo.png",
        "prefill": { 
          // "name": "Harshil Mathur",
           "email": this.state.uemail,
           "contact": this.state.uphonenumber
         },
        handler: async (response) => {
          try {
            const API_URL = process.env.REACT_APP_NODE_ENV;
            const bodyParameters = { 
              amount_data: 100 * addamount,
              acc_amount: addamount,  
              user_id: this.state.usid,
              ords_id: this.state.ordId, 
              transtype: 'deposit'
  
           };
            
  
           const paymentId = response.razorpay_payment_id;
           const url = `${API_URL}/api/transactionpayment/${paymentId}`;
           const captureResponse = await Axios.post(url,bodyParameters, {})
           const doesToggle = this.state.paySlot;
            this.setState({  paySlot: !doesToggle })
          
           if(captureResponse.data) {
                    
             
            fetch(process.env.REACT_APP_NODE_ENV + '/api/wallet/transaction', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
              },
              body: JSON.stringify(bodyParameters_data)
            }).then((response) => response.json())
              .then(data => {
                if(data) {
                  
                  localStorage.removeItem("pay_data");
                  
                  let data_string= {
                    paymentdetails: data.data_get,
                    user_id: this.state.usid, 
                    p_id: data.payment_id,
                    ordcontinue: this.state.ordercontinue,
                    passdata : 'wallet'
        
                  } 
                  localStorage.setItem('pay_data', JSON.stringify(data_string));
        
        
                  this.props.history.push({ pathname: "/order/payedsuccess"  }); 
        
        
        
                }
                //this.setState({ wal_amount : data.wallet_amount })
                //console.log(data.wallet_amount)
              })



  
           }
          } catch (err) { 
            console.log(err);
          }
        },
        "theme": {
          "color": "#000080"  
        }
      };
  
      const rzp1 = new window.Razorpay(options);
         rzp1.open();
    }
    else {
      const addamount =   this.state.wal_amount - bodyParameters_data.order_price
      console.log(addamount)

    }
   

  }

  cashondelivery () {
    // console.log(this.state.ordId);
     let postAddressData = { ords_id : this.state.ordId }
    fetch(process.env.REACT_APP_NODE_ENV + '/api/cashondelivery/order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postAddressData)
    }).then((response) => response.json())
      .then(data => {
        console.log(data.dataReceived)
		
			let data_string= {
				paymentdetails: '',
				user_id: this.state.usid, 
				p_id: '',
				ordcontinue: this.state.ordercontinue,
				passdata : 'cashondelivery'

			  } 
        localStorage.setItem('pay_data', JSON.stringify(data_string));
        if(data.dataReceived === '1') {
          this.props.history.push({ pathname: "/order/deliverysuccess" });

        }
        else {
          this.props.history.push({ pathname: "/order/deliverysuccess" });
        }
        //console.log(data.wallet_amount)
      }) 

  }

  componentDidMount() {
    

    this.setState({ordId: this.props.match.params.id})
      let postorderdata = { cust_id: this.props.match.params.cuid,  orderdeliverId :this.props.match.params.id }
    console.log(postorderdata)
     
  

      fetch(process.env.REACT_APP_NODE_ENV + '/api/order/orderpendingdetails', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postorderdata)
      }).then((response) => response.json())
        .then(data => {

          console.log(data.orderdetails.length)
          if(data.orderdetails.length ===  1) {
            this.setState({ orderdetails : data.orderdetails, totalprice: data.totalprice,  f_address : data.orderdetails[0].fullAddress  })
           
          } 
		 else if(data.orderdetails.length > 1) {
            this.setState({ orderdetails : data.orderdetails, totalprice: data.totalprice,  f_address : data.orderdetails[0].fullAddress  })
           
          } 
          else if(data.orderdetails.length ===  0) {
            this.props.history.push({ pathname: "/" });
          }
          else {
            this.setState({ orderdetails : data.orderdetails, totalprice: data.totalprice,  f_address : data.orderdetails[0].fullAddress  })
           
          }

         
           //console.log(data)

        })
        
        let postAddressData = { user_id : this.props.match.params.userid  }
        fetch(process.env.REACT_APP_NODE_ENV + '/api/wallet/amount', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify(postAddressData)
        }).then((response) => response.json())
          .then(data => {
            this.setState({ wal_amount : data.wallet_amount })
            //console.log(data.wallet_amount)
          }) 






        let userpostdata= { user_id :  this.props.match.params.userid }
        fetch(process.env.REACT_APP_NODE_ENV + '/api/customer/get_profile', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify(userpostdata)
        }).then((response) => response.json())
          .then(data => {
           // console.log(data)


          })

          let userdetail = { user_id :  this.props.match.params.userid }
          fetch(process.env.REACT_APP_NODE_ENV + '/api/user/getUserdetailsId', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(userpostdata)
          }).then((response) => response.json())
            .then(data => {
              
              this.setState({ usid: data.id , uemail: data.userEmail, uphonenumber : data.userPhoneNumber  })
             
  
  
            })

          
    let postpayment = {}
		fetch(process.env.REACT_APP_NODE_ENV + '/api/configsetting/paymentfetchall', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postpayment)
      }).then((response) => response.json())
        .then(data => {
          if(data) {
          console.log(data.paymentdetails[0])
		   this.setState({ paymentidmode: 	data.paymentdetails[0].payment_key_id    })
		  }
		  else {
			   this.setState({ paymentidmode: 	'0'	   })
		  }
         


        })

    
      
  }

  openCheckout() {
	 
    let options = {
      "key": this.state.paymentidmode,
      "amount": 100 * this.state.totalprice, // 2000 paise = INR 20, amount in paisa
      "name": "Gowatr",
      "user_d": this.state.userId,
      "description": "Order Payment",
       "image": "/media/logos/newlogo.png",
      "prefill": {
        // "name": "Harshil Mathur",
         "email": this.state.uemail,
         "contact": this.state.uphonenumber
       },
      handler: async (response) => {
        try {
          const API_URL = process.env.REACT_APP_NODE_ENV;
          const bodyParameters = { 
            amount_data: 100 * this.state.totalprice,
            acc_amount: this.state.pay_amount,  
            user_id: this.props.userId,
            ords_id: this.state.ordId, 
            transtype: 'deposit'

         };
          

         const paymentId = response.razorpay_payment_id;
         const url = `${API_URL}/api/orderpayment/${paymentId}`;
         const captureResponse = await Axios.post(url,bodyParameters, {})
         console.log(captureResponse.data);
         if(captureResponse.data) {
          const doesToggle = this.state.paySlot;
          this.setState({  paySlot: !doesToggle });
         
           console.log(this.state.ordercontinue)
          let data_string= {
            paymentdetails: captureResponse.data,
            user_id: this.state.usid, 
            p_id: captureResponse.data.paymentid,
            ordcontinue: this.state.ordercontinue

            

          } 
          localStorage.setItem('pay_data', JSON.stringify(data_string));
          this.props.history.push({ pathname: "/order/payedsuccess"});

         }
        } catch (err) { 
          console.log(err);
        }
      },
      "theme": {
        "color": "#000080" 
      }
    };

    const rzp1 = new window.Razorpay(options);
       rzp1.open();
  }

  render() { 
    const { intl } = this.props  ;
    const { isRequested } = this.state;

    if (isRequested) {
      return <Redirect to="/auth" />;
    }
    let paySlots = null;
    if (this.state.paySlot) {
      paySlots = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Please Wait Payment is Processing ....</ModalHeader>
              <ModalBody>
                       <Spinner animation="border" />
              </ModalBody>
              <ModalFooter>
                  Do Not Refresh or GoBack
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    return (
      <>
        
          <Breadcrumb>
            <Breadcrumb.Item active>Order Payment</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "10px" }}> 
          <div className="kt-form__section kt-form__section--first">
             <div className="kt-wizard-v1__form">
<Card>
  <Card.Header></Card.Header>
  <Card.Body>
  {paySlots}
    { /* <!--- <div class="form-group row">
     <div className="col-lg-4">
        <label style= {{  fontSize:"16px" }}>Wallet Amount : { this.state.wal_amount }.00 INR</label>
       </div>
					<div className="col-lg-4">
							<input type='text' className="form-control" onChange={ this.changeAmount }  placeholder="Enter a Amount" />
						</div>
						<div className = "col-lg-2">
							<Button  variant="outline-success"   onClick={this.openCheckout}>Pay Rs. {this.state.amount/100}</Button> 
						</div> 
      </div>    ---> */ }
          <Table striped borderless hover style={{ width:"75%" }}>
  <thead>
    <tr>
      <th>Order Summary</th>
      <th>Delivery Date</th>
      <th>Price</th>
     
    </tr>
    {
            this.state.orderdetails.map(function(ub) {
			var date_user=dateFormat(ub.deliveryDate, 'dd/mm/yyyy')
              return (
                <tr>
                    <td>{ub.orderId} 
                      <br />   
                      1* {ub.quantity}                 
                    </td>
					<td>{ date_user }</td> 
                    <td>{ub.orderPrice}</td>
                    
                </tr>
            )
        })
        
        
        
            }
            <tr>
              <td></td>
              <td style={{ borderTop:"1px solid #000" }}>Total</td>
              <td style={{ borderTop:"1px solid #000" }}>{this.state.totalprice}</td>
            </tr>
       
           

   
  </thead>
  <tbody>
    
    
  </tbody>
</Table>
<div  style={{ borderTop:"2px solid #eee" , padding:"15px 12px" }} >
   <b>Shipping Address :</b>
          <p style={{  margin:"15px 0px"  }} >{ this.state.f_address }</p>
  </div>
<div className="form-group row" style={{ borderTop:"2px solid #eee" , padding:"15px 12px" }}>
 <div className="col-xs-5">
  <b>Payment Method :</b> <br /> <br />
    <div onChange={this.onChangeValue} style={{ padding:"0px 10px" }}>
  
          <input type="radio" value="COD" id="upayment" name="payment"  /><span style={{ padding:"0px 5px" }}><img src="/media/logos/cash1.png" style={{ width:"40px", padding: "0px 10px;" }} /> Cash On Delivery</span>  <br /><br />
          <input type="radio" value="razorpay" id="upayment" name="payment"  /> <span style={{ padding:"0px 5px" }}><img src="/media/logos/razorpay.png" style={{ width:"40px", padding: "0px 10px;" }} /> Pay use in Razorpay</span> <br /><br />
         <input type="radio" value="wallet"  name="payment" defaultChecked /> <span style={{ padding:"0px 5px" }}><img src="/media/logos/wallet.png" style={{ width:"40px", padding: "0px 10px;" }} /> Pay use in wallet Balance <b>RS. { this.state.wal_amount } </b> </span>  
      </div>
  </div>
 
 </div>



	<ModalFooter className="pull-left">
                  <Button variant="outline-success"
                    onClick={this.submit} >
                    Submit
                  </Button>&nbsp;&nbsp;&nbsp;
                  <Button variant="outline-warning"
                    onClick={() => this.props.history.push({ pathname: "/"  })  } >
                    Cancel
                  </Button>
                </ModalFooter>

          

    
  </Card.Body>
</Card>





              
                  </div> 
                
            </div>
           
          

          </div>
        </>
     
    );
  }
}

export default injectIntl(
  connect(
    null,
    auth.actions
  )(Paymentpage)
);
